import { Slider } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { TableCellEntityMode } from 'entities/TableCell';
import { TableProgressBarController } from 'stores/common';

import { TableControllerProps } from '../types';

const ProgressBarController: React.FC<
  TableControllerProps<TableProgressBarController>
> = ({ record, className, params }) => {
  const controllerDisabled = params?.mode === TableCellEntityMode.disabled;

  return (
    <Slider
      value={record.controllerValue}
      max={record.maxValue}
      onChange={record.setValue}
      className={className}
      disabled={controllerDisabled}
    />
  );
};

export default observer(ProgressBarController);
